export const getFirstName = (name: string) => {
  const splitNames = name.split(' ');
  return splitNames.length > 1 ? splitNames.slice(0, splitNames.length - 1).join(' ') : splitNames[0];
};
